import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
interface DefinitionsContextValue {
  isOpen: boolean;
  openId: string | null;
  open: (id?: string) => void;
  close: () => void;
}
const DefinitionsContext = createContext<DefinitionsContextValue | null>(null);
export function DefinitionsProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [state, setState] = useState<{
    isOpen: boolean;
    openId: string | null;
  }>({
    isOpen: false,
    openId: null
  });
  const open = useCallback((id?: string) => setState({
    isOpen: true,
    openId: id ?? null
  }), []);
  const close = useCallback(() => setState(s => ({
    ...s,
    isOpen: false
  })), []);
  const value = useMemo(() => ({
    ...state,
    open,
    close
  }), [state, open, close]);
  return <DefinitionsContext.Provider value={value} data-id="element-764" data-mp="26h4f896dmgzo">{children}</DefinitionsContext.Provider>;
}
export function useDefinitions(): DefinitionsContextValue {
  const ctx = useContext(DefinitionsContext);
  if (!ctx) throw new Error('useDefinitions must be used inside DefinitionsProvider');
  return ctx;
}